import React from 'react';
import { Link } from 'react-router-dom';

import { ToroLearnIcon } from '../icon';

import './styles.scss';

interface IProps {
    children?: React.ReactNode
    href?: string
    btnType?: string
    btnSize?: 'btn-lg' | 'btn-sm'
    isFull?: boolean
    icon?: string;
    onClick?: VoidFunction,
}

export const ToroLearnButton = ({
    children,
    href = '#',
    btnType = 'btn-primary',
    btnSize,
    isFull,
    icon,
    onClick,
}: IProps) => {
    const isOutline = btnType.includes('outline');
    return (
        <Link
            to={href}
            className={`btn ${btnType} ${btnSize !== undefined ? btnSize : ''} ${isFull ? 'w-100' : ''}`}
            onClick={onClick}>
            <div className="d-flex align-items-center">
                {icon && <ToroLearnIcon icon={icon} size={24} className={`icon ${isOutline ? 'is-outline' : 'is-not-outline'}`} />}
                {children && children}
            </div>
        </Link>
    );
};
